import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRecentSnippetList } from "../../auth/firebase/snippets/Controller"

import "../../assets/css/SnippetCard.css";

function RecentCards() {

  const [snippets, setSnippets] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!snippets && snippets.length === 0) {
      getRecentSnippetList()
        .then((list) => {
          setSnippets(list);
        })
    }
  }, [snippets]);


  const cardSection = () => {
    return (

      <div className="container px-4 py-5 snippet-cards">
        <div className="row">
        <h2 className="pb-2 border-bottom">Recent Code Snippets</h2>
        {
          snippets && snippets.length > 0 ? (
            snippets.map((snippet, index) =>
            <button className="col-md-4 align-items-stretch g-4 py-5 default-link" key={index} onClick={() => navigate("/snippet/" + snippet.id)}>

                <div className="col">
                  <div className="card card-cover h-100 overflow-hidden text-white bg-dark rounded-5 shadow-lg">
                    <div className="d-flex flex-column h-100 p-5 pb-3 text-white text-shadow-1">
                      <h2 className="mb-4 display-6 lh-1 fw-bold">{snippet.title}</h2>
                      <p>{snippet.description}</p>
                      <ul className="d-flex list-unstyled mt-auto">
                        {
                          snippets.tags && snippets.tags.length > 0 ? (
                            snippets.tags.map((tag, tindex) => {
                              return (
                                <li className="d-flex align-items-center me-3" key={index + "-" + tindex}>
                                  <small>{tag}</small>
                                </li>
                              )
                            })
                          ) : ("")
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </button>
            )
          ) : ("")
        }
        </div>
      </div>

    );
  }


  return (
      cardSection()
  );
}
export default RecentCards;


